import React from "react";
import { Box, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { CountDownTimer } from "../countdown/countdownTimer";
import { useContractContext } from "../../context/contract-info";

export default function RGPTCampo() {
  const classes = useStyles();
  const { poolSize, endTime } = useContractContext()

  return (
    <div className={classes.mainContainer}>
      <Box>
        <Typography
          variant="h3"
          sx={{
            fontWeight: 700,
            fontSize: 30,
            fontFamily: "Montserrat",
            color: "#FFE921",
          }}
        >
          Pool Balance {poolSize}
        </Typography>
      </Box>

      <Box>
        <Typography
          variant="h3"
          sx={{
            fontWeight: 700,
            fontSize: 12,
            fontFamily: "Montserrat",
            color: "#FFF",
          }}
        >
          NEXT $RGPT Distribution
        </Typography>
      </Box>
      <Box>
        {endTime && <CountDownTimer time={parseInt(endTime) * 1000} />}
      </Box>
    </div>
  );
}
const useStyles = makeStyles((theme) => ({
  mainContainer: {
    width: 500,
    margin: "0 auto",
    padding: "20px 20px 20px 20px",
    border: "1px solid #FFFFFF",
    borderRadius: 63,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    rowGap: 20,
    [theme.breakpoints.down("sm")]: {
      width: "75%",
    },
  },
}));
